/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2021, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */

function slideToggle(t, e, o) {
	0 === t.clientHeight ? j(t, e, o, !0) : j(t, e, o)
}

function slideUp(t, e, o) {
	j(t, e, o)
}

function slideDown(t, e, o) {
	j(t, e, o, !0)
}

function j(t, e, o, i) {
	void 0 === e && (e = 400), void 0 === i && (i = !1), t.style.overflow = "hidden", i && (t.style.display = "block");
	var p, l = window.getComputedStyle(t), n = parseFloat(l.getPropertyValue("height")), a = parseFloat(l.getPropertyValue("padding-top")),
		s = parseFloat(l.getPropertyValue("padding-bottom")), r = parseFloat(l.getPropertyValue("margin-top")),
		d = parseFloat(l.getPropertyValue("margin-bottom")), g = n / e, y = a / e, m = s / e, u = r / e, h = d / e;
	window.requestAnimationFrame(function l(x) {
		void 0 === p && (p = x);
		var f = x - p;
		i ? (t.style.height = g * f + "px", t.style.paddingTop = y * f + "px", t.style.paddingBottom = m * f + "px", t.style.marginTop = u * f + "px", t.style.marginBottom = h * f + "px") : (t.style.height = n - g * f + "px", t.style.paddingTop = a - y * f + "px", t.style.paddingBottom = s - m * f + "px", t.style.marginTop = r - u * f + "px", t.style.marginBottom = d - h * f + "px"), f >= e ? (t.style.height = "", t.style.paddingTop = "", t.style.paddingBottom = "", t.style.marginTop = "", t.style.marginBottom = "", t.style.overflow = "", i || (t.style.display = "none"), "function" == typeof o && o()) : window.requestAnimationFrame(l)
	})
}

let sidebarItems = document.querySelectorAll('.sidebar-item.has-sub');
if(sidebarItems) {
	for(let i = 0; i < sidebarItems.length; i++) {
		let sidebarItem = sidebarItems[i];
		sidebarItem.querySelector('.sidebar-link').addEventListener('click', function(e) {
			e.preventDefault();

			let submenu = sidebarItem.querySelector('.submenu');
			if(submenu) {
				if(submenu.classList.contains('active')) {
					submenu.style.display = "block";
				}

				if(submenu.style.display == "none") {
					submenu.classList.add('active');
				} else {
					submenu.classList.remove('active');
				}
				slideToggle(submenu, 300);
			}
		});
		let submenu = sidebarItem.querySelector('.submenu');
		if(submenu) {
			let submenuItems = submenu.querySelectorAll('.submenu-item');
			if(submenuItems) {
				for(let j = 0; j < submenuItems.length; j++) {
					if(submenuItems[j].classList.contains('active')) {
						sidebarItem.classList.add('active');
						submenu.style.display = 'block';
						submenuItems[j].scrollIntoView(false);
					}
				}
			}
		}
	}
}

/*window.addEventListener('DOMContentLoaded', (event) => {
	var w = window.innerWidth;
	if(w < 1200) {
		toggleSidebar(false);
	}
});
window.addEventListener('resize', (event) => {
	var w = window.innerWidth;
	if(w < 1200) {
		toggleSidebar(false);
	} else {
		toggleSidebar(true);
	}
});*/

const dataStorage = localStorage;

window.addEventListener('DOMContentLoaded', (evt) => {
	if(dataStorage) {
		let state = dataStorage.getItem('sidebarState');
		if(state) {
			let classes = document.getElementById('app').classList;
			classes.remove('sidebar-auto');
			if(state === 'on') {
				classes.add('sidebar');
			} else if(state === 'off') {
				classes.remove('sidebar');
			}
		}
	}
});

// переключение боковой панели
function toggleSidebar() {
	let classes = document.getElementById('app').classList;
	// при первом же ручном воздействии отключаем автоматическое поведение панели
	if(classes.contains('sidebar-auto')) {
		classes.remove('sidebar-auto');
		classes.add('sidebar');
	}
	let state = classes.toggle('sidebar');
	dataStorage && dataStorage.setItem('sidebarState', state ? 'on' : 'off');
}

// возвращает автоматический режим боковой панели
function releaseSidebar() {
	let classes = document.getElementById('app').classList;
	classes.add('sidebar-auto');
	classes.remove('sidebar');
	dataStorage && dataStorage.removeItem('sidebarState');
}
let sidebarRelease = document.querySelector('.sidebar-release');
if(sidebarRelease) {
	sidebarRelease.addEventListener('click', (evt) => {
		evt.preventDefault();
		releaseSidebar();
	});
}
let burger = document.querySelector('.burger-btn');
if(burger) {
	burger.addEventListener('click', (evt) => {
		evt.preventDefault();
		toggleSidebar();
	});
}
let sidebarHide = document.querySelector('.sidebar-hide');
if(sidebarHide) {
	sidebarHide.addEventListener('click', (evt) => {
		evt.preventDefault();
		toggleSidebar();
	});
}

// Perfect Scrollbar Init
if(typeof PerfectScrollbar == 'function') {
	const container = document.querySelector(".sidebar-wrapper");
	if(container) {
		const ps = new PerfectScrollbar(container, {
			wheelPropagation: false
		});
	}
}

// Scroll into active sidebar
let activeSidebarItem = document.querySelector('.sidebar-item.active');
if(activeSidebarItem) {
	activeSidebarItem.scrollIntoView(false);
}

yii.confirm = function(message, ok, cancel) {
	Swal.fire({
		title: 'Вы уверены?',
		text: message,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText: 'Да!',
		cancelButtonText: 'Нет, отменить!',
		reverseButtons: true
	}).then((result) => {
		if(result.isConfirmed) {
			!ok || ok();
		} else if(result.isDismissed) {
			!cancel || cancel();
		}
	})
};

/**
 * Заполнение email из поля login при напоминании пароля
 */
$('#account-remember-link').on('click', function(evt) {
	let email = $('input[name="LoginForm[login]"]').val();
	if(email) {
		evt.preventDefault();
		var url = new URL($(this).attr('href'), window.location.href);
		url.searchParams.set('email', email);
		window.location.href = url.toString();
	}
});

(function() {
	var list = $('#social-accounts-list');
	function send(node) {
		let id = node.parent('li').data('id');
		$.ajax({
			'url': '/office/account/toggle-auth',
			'type': 'post',
			'dataType': 'json',
			'data': {
				'id': id
			}
		}).done(function(response) {
			if(response.success) {
				if(response.html) {
					node.replaceWith($(response.html));
				}
				toastr.success(response.message);
			} else {
				toastr.warning(response.message);
			}
		}).fail(function() {
			toastr.error('Ошибка при отправке данных');
		});
	}
	list.on('click', 'button.btn', function(evt) {
		let self = $(this);
		if(self.is('.btn-warning')) {
			Swal.fire({
				title: 'Вы уверены?',
				text: self.data('i18n-confirm'),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Да!',
				cancelButtonText: 'Нет, отменить!',
				reverseButtons: true
			}).then((result) => {
				if(result.isConfirmed) {
					send(self);
				}
			});
		} else {
			send(self);
		}
	});
})();

(function($, window, undefined) {
	var DeferredCallback = $.DeferredCallback = $.DeferredCallback || {};
	/**
	 * Unique counter for registered functions
	 * @type {Number}
	 */
	var counter = 0;
	/**
	 * @type {Array} List of registered functions
	 */
	var functions = [];
	/**
	 * Registers function for delayed call
	 * @param {Function} callable
	 * @param {Object|Array} args
	 * @param {Object} context
	 * @returns {number}
	 */
	DeferredCallback.registerFunction = function(callable, args, context) {
		if(!$.isFunction(callable)) {
			$.error('First argument should be a {Function}');
		}
		context = context || DeferredCallback;
		args = args || [];
		functions[++counter] = {callable: callable, context: context, args: args};
		return counter;
	};
	/**
	 *
	 * @param {Number} index
	 * @param {Array} args
	 * @returns {*}
	 */
	DeferredCallback.callFunction = function(index, args) {
		if(functions[index] && $.isFunction(functions[index].callable)) {
			var func = functions[index];
			return func.callable.apply(func.context, $.extend(func.args, args));
		}
		$.error('Function not exists or not an {Function}');
	};
})(jQuery, window);

/**
 * Массовая загрузка изображений
 */
(function() {
	var Api;
	Api = new Vue({
		/* настройки */
		defaults: {},
		options: {
			selector: null,
			uploadUrl: '',
			modelName: null
		},
		data: {
			input: null,
			groups: [],
			form: null,
		},
		computed: {
			allowed: function() {
				return this.maxFiles - this.images.length;
			},
		},
		methods: {
			defaults: function() {
				return {
					ajaxTimeout: 120000,
					maxFiles: 25
				};
			},
			/* инициализация */
			init: function(options) {
				var self = this;
				this.options = Object.assign({}, this.defaults(), options);
				this.maxFiles = this.options.maxFiles;
				var container = $('#' + this.options.selector);
				this.form = container.parents('form');
				this.input = this.form.find('input[type="file"]');
				this.form.on('beforeSubmit', self.upload);
			},
			upload: function(event) {
				var self = this;
				var formData = new FormData(event.target);
				var upload = formData.getAll(this.options.modelName + '[files][]');
				upload = upload.filter(function(element) {
					return element !== '';
				});
				if(this.options.maxFiles < upload.length) {
					toastr.warning('Максимально возможно кол-во файлов: ' + this.options.maxFiles + '. Некоторые из добавленных файлов загружены не будут.');
					upload.length = this.options.maxFiles;
				}
				var images = [];
				upload.map(function(element) {
					var thumbnail = FileAPI.Image(element);
					return thumbnail.preview(120, 90).get(function(err, img) {
						images.push(img.toDataURL("image/png"));
					});
				});
				var group = {
					images: images,
					progress: 0,
					success: null,
					classes: ['bg-info', 'progress-bar-striped', 'progress-bar-animated']
				};
				this.groups.unshift(group);
				$.ajax(this.form.attr('action'), {
					async: true,
					method: 'POST',
					contentType: false,
					processData: false,
					timeout: self.options.ajaxTimeout,
					data: formData,
					xhr: function() {
						var xhr = new window.XMLHttpRequest();

						// Upload progress
						xhr.upload.addEventListener("progress", function(evt) {
							if(evt.lengthComputable) {
								group.progress = 100 * evt.loaded / evt.total;
							}
						}, false);
						return xhr;
					}
				}).done(function(data, textStatus, jqXHR) {
					if(data.success) {
						self.input.val('');
						group.progress = 100;
						group.success = true;
						group.classes = ['bg-success'];
						toastr.success(data.message);
					} else {
						group.classes = ['bg-danger'];
						group.success = false;
						toastr.error(data.message);
					}
				}).fail(function(jqXHR, textStatus, errorThrown) {
					group.success = false;
					group.classes = ['bg-danger'];
					if(jqXHR.responseJSON) {
						if(jqXHR.responseJSON.hasOwnProperty('length')) {
							toastr.error(jqXHR.responseJSON[0].message);
						} else {
							toastr.error(jqXHR.responseJSON.message);
						}
					} else {
						toastr.error(textStatus);
					}
				});
				return false;
			}
		}
	});
	window.BatchUpload = function(options) {
		Api.$on(['hook:mounted'], function() {
			Api.init(options);
		});
		if($('#' + options.selector).length) {
			Api.$mount('#' + options.selector);
		}
		return Api;
	};
})();

/**
 * Массовая загрузка файлов
 */
(function() {
	var Api;
	Api = new Vue({
		/* настройки */
		defaults: {},
		options: {
			selector: null,
			uploadUrl: '',
			modelName: null
		},
		data: {
			input: null,
			groups: [],
			form: null
		},
		computed: {
			allowed: function() {
				return this.maxFiles - this.files.length;
			},
		},
		methods: {
			defaults: function() {
				return {
					ajaxTimeout: 120000,
					maxFiles: 25
				};
			},
			/* инициализация */
			init: function(options) {
				var self = this;
				this.options = Object.assign({}, this.defaults(), options);
				this.maxFiles = this.options.maxFiles;
				var container = $('#' + this.options.selector);
				this.form = container.parents('form');
				this.input = this.form.find('input[type="file"]');
				this.form.on('beforeSubmit', self.upload);
			},
			upload: function(event) {
				var self = this;
				var formData = new FormData(event.target);
				var upload = formData.getAll(this.options.modelName + '[files][]');
				upload = upload.filter(function(element) {
					return element !== '';
				});
				if(this.options.maxFiles < upload.length) {
					toastr.warning('Максимально возможно кол-во файлов: ' + this.options.maxFiles + '. Некоторые из добавленных файлов загружены не будут.');
					upload.length = this.options.maxFiles;
				}
				var files = [];
				upload.map(function(element) {
					files.push(element);
				});
				var group = {
					files: files,
					progress: 0,
					success: null,
					classes: ['bg-info', 'progress-bar-striped', 'progress-bar-animated']
				};
				this.groups.unshift(group);
				$.ajax(this.form.attr('action'), {
					async: true,
					method: 'POST',
					contentType: false,
					processData: false,
					timeout: self.options.ajaxTimeout,
					data: formData,
					xhr: function() {
						var xhr = new window.XMLHttpRequest();

						// Upload progress
						xhr.upload.addEventListener("progress", function(evt) {
							if(evt.lengthComputable) {
								group.progress = 100 * evt.loaded / evt.total;
							}
						}, false);
						return xhr;
					}
				}).done(function(data, textStatus, jqXHR) {
					if(data.success) {
						self.input.val('');
						group.progress = 100;
						group.success = true;
						group.classes = ['bg-success'];
						toastr.success(data.message);
					} else {
						group.classes = ['bg-danger'];
						group.success = false;
						toastr.error(data.message);
					}
				}).fail(function(jqXHR, textStatus, errorThrown) {
					group.success = false;
					group.classes = ['bg-danger'];
					if(jqXHR.responseJSON) {
						if(jqXHR.responseJSON.hasOwnProperty('length')) {
							toastr.error(jqXHR.responseJSON[0].message);
						} else {
							toastr.error(jqXHR.responseJSON.message);
						}
					} else {
						toastr.error(textStatus);
					}
				});
				return false;
			}
		}
	});
	window.BatchFileUpload = function(options) {
		Api.$on(['hook:mounted'], function() {
			Api.init(options);
		});
		if($('#' + options.selector).length) {
			Api.$mount('#' + options.selector);
		}
		return Api;
	};
})();
